import * as React from 'react'
import { HubItem } from '../../reducers/hub'
import { strings } from '../../lib/localization'

interface MenuItemProps {
  item: HubItem
  isActive: boolean
  onClick: (item: HubItem) => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MenuItemState {}

function getHubItemIcon(hubItem: HubItem) {
  if (hubItem.icon) {
    return <img src={hubItem.icon} alt={hubItem.name} />
  } else {
    switch (hubItem.type) {
      case 'online':
      case 'bot':
        return <i className='material-icons'>forum</i>
      case 'form':
        return <i className='material-icons'>email</i>
      default:
        return <i className='material-icons'>help</i>
    }
  }
}

class MenuItem extends React.Component<MenuItemProps, MenuItemState> {
  handleHubItemClick = (e: React.MouseEvent<HTMLElement>) => {
    this.props.onClick(this.props.item)
  }

  handleHubItemKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.onClick(this.props.item)
    }
  }

  getFormId(str: string) {
    if (str.includes('-')) {
      return str.split('-')[1]
    }
    return str
  }

  getName() {
    const formId = this.getFormId(this.props.item.id)
    switch (this.props.item.type) {
      case 'answers':
        return (
          this.props.item.name ||
          strings['defaultHubAnswersName-' + formId] ||
          strings.defaultHubAnswersName
        )
      case 'form':
        return (
          this.props.item.name ||
          strings['defaultHubFormName-' + formId] ||
          strings.defaultHubFormName
        )
      default:
        return this.props.item.name || ''
    }
  }

  render() {
    const shouldShowBadge =
      typeof this.props.item.badgeCount !== 'undefined' &&
      this.props.item.badgeCount > 0
    const liClasses = this.props.item.groupId
      ? `menuitem-groupid-${this.props.item.groupId}`
      : ''
    const name = this.getName()
    return (
      <li className={liClasses}>
        <div
          onClick={this.handleHubItemClick}
          role='button'
          tabIndex={0}
          onKeyDown={this.handleHubItemKeyDown}
          className={
            'menu-item ' +
            (this.props.isActive ? ' active' : ' ') +
            (this.props.item.disabled ? ' disabled' : '')
          }
        >
          {getHubItemIcon(this.props.item)}

          <span className='menu-item-name'>
            <div>{name}</div>
          </span>

          {shouldShowBadge && (
            <span className='badge badge-pill badge-primary'>
              {this.props.item.badgeCount}
            </span>
          )}
        </div>
      </li>
      /*
      <img src={this.props.item.agentPicture} />
      <div className="hubitem" onClick={this.handleHubItemClick}>
        <Emojify>{this.props.item.name}</Emojify>
        {shouldShowBadge && <span className="badge badge-pill badge-primary">
          {this.props.item.badgeCount}
        </span>}
      </div>
      **/
    )
  }
}

export { MenuItem }
